module.exports = __webpack_public_path__ + "img/button-tg.ec5d1acc.svg";